import cx from 'classnames';
import { Button } from '@vimily/bonjoro-ui-components';
import React from 'react';
import { SpinnerNew as Spinner } from '~/App/Components/Shared/Spinner';

interface AddTagProps {
  name: string;
  setName: (name: string) => void;
  className: string;
  onAddClick?: () => void;
  loading?: boolean;
}

export default function AddTag({
  name,
  setName,
  className,
  onAddClick,
  loading = false
}: AddTagProps){

  return (
    <div className={cx(className, 'flex flex-row')}>
      <input
        type='text'
        className={'form-control mr-4 basis-5/6 !text-neutral-600'}
        placeholder="Tag name"
        onChange={(event: React.FormEvent<HTMLInputElement>) =>
          setName(event.currentTarget.value)
        }
        value={name}
      />
      <Button
        className='w-full basis-1/6'
        onClick={onAddClick}
        disabled={loading || name === ''}
      >
        {!loading ? 'Add' : <Spinner />}
      </Button>
    </div>
  );
}
